import { Button } from "@studyplus/boron-ui";
import { ConfirmUpdateTypeModal } from "../../../containers/pages/StudentsCalendar/ConfirmUpdateTypeModal";
import { UpdateType } from "../../../domains/Schedule";
import { SectionSchedule } from "../../../domains/SectionSchedule";
import { useFlashMessage } from "../../../hooks/useFlashMessage";
import SectionInterface from "../../../interfaces/SectionInterface";
import { useDeleteSectionSchedule } from "../useDeleteSectionSchedule";

type Props = {
  section: SectionInterface;
  sectionSchedule: SectionSchedule;
  onClose: () => void;
};

export const ConfirmToDelete = ({
  section,
  sectionSchedule,
  onClose,
}: Props) => {
  const { showSuccessMessage, showErrorMessage } = useFlashMessage();

  const { mutate, isPending } = useDeleteSectionSchedule({
    section,
    onSuccess() {
      showSuccessMessage("削除を完了しました");
      onClose();
    },
    onError() {
      showErrorMessage("予定の削除に失敗しました");
    },
  });

  const handleDelete = (updateType: UpdateType) => {
    mutate({
      scheduleId: sectionSchedule.id,
      updateType,
    });
  };

  return (
    <ConfirmUpdateTypeModal
      headerLabel="繰り返し予定の削除"
      onClose={onClose}
      buttonsArea={(chosen) => (
        <div>
          <Button
            disabled={isPending}
            isLoading={isPending}
            onClick={() => handleDelete(chosen)}
          >
            削除
          </Button>
        </div>
      )}
    />
  );
};
